// ItemRow (drawing v2.6, `row1()`; standard rule 4): a mark 44 by 44, the name
// with at most one badge, why it matters, a meta line, one clear button and a
// More menu. On a row about a person, up to two icon quick actions (call,
// email) before the button. The first row's button is navy only when the
// list is sorted by urgency. Density: compact 8 by 16, standard 16 by 24,
// comfortable 20 by 24 (reference section 20).

import type { ReactNode } from "react";
import { cx } from "./cx";

export type Density = "compact" | "standard" | "comfortable";

export interface ItemRowProps {
  /** The mark: an icon, initials or a number. */
  mark: ReactNode;
  markTone?: "info" | "warn";
  name: ReactNode;
  badge?: ReactNode;
  why?: ReactNode;
  meta?: ReactNode;
  /** Up to two IconButtons (call, email) on a row about a person. */
  quickActions?: ReactNode;
  /** The one labeled button. */
  action?: ReactNode;
  /** The More menu (a Menu with an IconButton trigger). */
  more?: ReactNode;
  density?: Density;
  className?: string;
  id?: string;
}

export function ItemRow({ mark, markTone = "info", name, badge, why, meta, quickActions, action, more, density = "standard", className, id }: ItemRowProps) {
  return (
    <div className={cx("pg-row", density === "compact" && "pg-row--compact", density === "comfortable" && "pg-row--comfy", className)} id={id}>
      <span className={cx("pg-mk", markTone === "warn" && "pg-mk--w")}>{mark}</span>
      <div className="pg-row__body">
        <div className="pg-row__name">
          {name}
          {badge}
        </div>
        {why && <div className="pg-row__why">{why}</div>}
        {meta && <div className="pg-row__meta">{meta}</div>}
      </div>
      {(quickActions || action || more) && (
        <div className="pg-row__end">
          {quickActions && <span className="pg-row__qa" style={{ display: "contents" }}>{quickActions}</span>}
          {action}
          {more}
        </div>
      )}
    </div>
  );
}

/** Rows stacked in one card. */
export function Rows({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cx("pg-rows", className)}>{children}</div>;
}
